import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    step: 1,
    lastOnboardStep: 1,
    values: {},
    skippedSteps: []
};

const onBoardWizardSlice = createSlice({
    name: 'onBoardWizard',
    initialState,
    reducers: {
        nextStep: (state) => {
            // Logic to go to the next step, considering skipped steps
            let nextStep = state.step + 1;

            if (state?.skippedSteps) {

                while (state.skippedSteps.includes(nextStep)) {
                    nextStep += 1;
                }
            }
            state.step = nextStep;
        },
        prevStep: (state) => {
            // Logic to go to the previous step, considering skipped steps
            let prevStep = state.step - 1;
            if (state?.skippedSteps) {
                while (state.skippedSteps.includes(prevStep)) {
                    prevStep -= 1;
                }
            }
            state.step = prevStep;
        },
        setStep(state, action) {
            state.step = action.payload;
        },
        setLastOnBoardStep(state, action) {
            state.lastOnboardStep = action.payload;
        },
        skipStep: (state, action) => {
            if (!state.skippedSteps.includes(action.payload)) {
                state.skippedSteps.push(action.payload);
            }
        },
        removeSkippedSteps: (state, action) => {
            const stepsToRemove = action.payload;
            if (stepsToRemove === 'all') {
                state.skippedSteps = [];
            } else {
                state.skippedSteps = state.skippedSteps.filter(step => !stepsToRemove.includes(step));
            }
        },
        handleOnChange(state, action) {
            const { key, value } = action.payload;
            if (key === 'FILE') {
                state.values.FILE = value;
            } else {
                state.values[key] = value;
            }
        },
        resetOnBoardValues(state) {
            return initialState;
        }
    },
});

export const { nextStep, prevStep, setStep, skipStep, setLastOnBoardStep, removeSkippedSteps, handleOnChange, resetOnBoardValues } = onBoardWizardSlice.actions;

export default onBoardWizardSlice.reducer;
